import React from 'react';
import {Stack, Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {RefundEnum} from 'presentation/constants';
import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {ModalsTypeEnum} from '../modalType';
import {TermsItem} from './types';

const {
	subtitle,
	titlePreview,
	subtitlePreview,
	subtitleAdditionalDocs,
	titleAdditionalDocs,
	title,
} = translations['pt-br'].privateFlow.refund.terms;

const {
	itemOne,
	itemOneCta,
	itemTwo,
	itemTwoOptions,
	itemTwoCta,
	itemThree,
	itemOnePreview,
	itemOnePreviewLegacy,
	itemOneOptions,
	itemTwoPreview,
	itemOneAdditionalDocs,
} = translations['pt-br'].privateFlow.refund.terms;

const {paragraph1: previewP1, paragraph2: previewP2, paragraph3: previewP3} = itemOnePreview;

const termsItemOne: TermsItem = {
	title: itemOne,
	iconName: 'file-document-outline',
	action: {
		name: itemOneCta,
		modal: ModalsTypeEnum.DOCUMENTS,
	},
	dataTagId: RefundTaggingEnum.CLICK_VER_LISTA_DE_DOCUMENTOS,
};

const termsItemTwo: TermsItem = {
	title: itemTwo,
	strongText: itemTwoOptions,
	iconName: 'attach-file-filled',
	action: {
		name: itemTwoCta,
		modal: ModalsTypeEnum.COMMUNICATE,
	},
	dataTagId: RefundTaggingEnum.CLICK_VER_COMUNICADO_ANS,
};

const termsItemThree: TermsItem = {
	iconName: 'app-shortcut-filled',
	title: itemThree,
};

const termsItemOnePreview: TermsItem = {
	title: (
		<Stack>
			<Typography variant="body1" color="text.primary">
				{previewP1.text1}
				<strong>{previewP1.bold1}</strong>
				{previewP1.text2}
				<strong>{previewP1.bold2}</strong>
				{previewP1.text3}
				<strong>{previewP1.bold3}</strong>
				{previewP1.text4}
				<strong>{previewP1.bold4}</strong>
				{previewP1.text5}
			</Typography>
			<Typography variant="body1" color="text.primary">
				{previewP2}
			</Typography>
			<Typography variant="body1" color="text.primary">
				{previewP3}
			</Typography>
		</Stack>
	),
	iconName: 'file-document-outline',
};

const termsItemTwoPreview: TermsItem = {
	title: itemTwoPreview,
	iconName: 'attach-file-filled',
	action: {
		name: itemOneCta,
		modal: ModalsTypeEnum.DOCUMENTS,
	},
	dataTagId: RefundTaggingEnum.CLICK_VER_LISTA_DE_DOCUMENTOS,
};

const termsItemOnePreviewLegacy: TermsItem = {
	title: itemOnePreviewLegacy,
	strongText: itemOneOptions,
	iconName: 'file-document-outline',
};

const termsItemTwoPreviewLegacy: TermsItem = {
	title: itemTwoPreview,
	iconName: 'attach-file-filled',
};

export const termsItemOneAdditionalDocuments: TermsItem = {
	title: itemOneAdditionalDocs,
	iconName: 'file-document-outline',
};

export const TermsItemsDefault: TermsItem[] = [termsItemOne, termsItemTwo, termsItemThree];

export const TermsItemsPreview: TermsItem[] = [
	termsItemOnePreview,
	termsItemTwoPreview,
	termsItemThree,
];

export const TermsItemsPreviewLegacy: TermsItem[] = [
	termsItemOnePreviewLegacy,
	termsItemTwoPreviewLegacy,
	termsItemThree,
];

export const TermsItemsAdditionalDocuments: TermsItem[] = [
	termsItemOneAdditionalDocuments,
	termsItemThree,
];

export const getTermsByType = (isNewPreviewMessageEnabled: boolean) => ({
	[RefundEnum.TERMS]: {
		items: TermsItemsDefault,
		title,
		subtitle,
		navigateTo: RefundEnum.REQUEST,
		showCaption: true,
		dataTagId: RefundTaggingEnum.CLICK_CONTINUAR_PARA_REEMBOLSO,
	},
	[RefundEnum.TERMS_PREVIEW]: {
		items: isNewPreviewMessageEnabled ? TermsItemsPreview : TermsItemsPreviewLegacy,
		title: titlePreview,
		subtitle: subtitlePreview,
		navigateTo: RefundEnum.REQUEST_PREVIEW,
		showCaption: false,
		dataTagId: RefundTaggingEnum.CLICK_CONTINUAR_PARA_PREVIA_REEMBOLSO,
	},
	[RefundEnum.TERMS_ADDITIONAL_DOCS]: {
		items: TermsItemsAdditionalDocuments,
		title: titleAdditionalDocs,
		subtitle: subtitleAdditionalDocs,
		navigateTo: RefundEnum.SENDING_DOCUMENTS,
		showCaption: false,
		dataTagId: RefundTaggingEnum.CLICK_CONTINUAR_PARA_ENVIO_DE_DOCUMENTOS,
	},
});
